export const Wait = (delayMS: number, callback: () => void) => {
    let id = setInterval(() => {
        clearInterval(id);
        callback();
    }, delayMS);
    return id;
};
